var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt-header"
  }, _vm._l((_vm.rows), function(row, idx) {
    return _c('div', {
      key: idx,
      staticClass: "gantt-row"
    }, _vm._l((row), function(obj, idx) {
      return _c('div', {
        key: idx,
        staticClass: "row-item",
        style: ({
          width: obj.width + 'px'
        }),
        attrs: {
          "title": obj.title
        },
        on: {
          "click": function($event) {
            _vm.$emit('header-click', obj)
          }
        }
      }, [_vm._v("\n      " + _vm._s(obj.label) + "\n    ")])
    }))
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ec7303"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GanttHeader.vue
// module id = 194
// module chunks = 1